const STORAGE_KEY = 'safe-display-plan-id'

export default {
  namespaced: true,
  state: {
    planList: [],
    selectedPlanId: null
  },
  mutations: {
    SET_PLAN_LIST (state, list) {
      state.planList = list || []
    },
    SET_SELECTED_PLAN_ID (state, planId) {
      state.selectedPlanId = planId
      if (planId != null) {
        localStorage.setItem(STORAGE_KEY, String(planId))
      }
    }
  },
  getters: {
    selectedPlan (state) {
      return state.planList.find(p => String(p.id) === String(state.selectedPlanId)) || null
    }
  }
}
